export const RESOURCE_DELIVERY_TYPES = {
    CACHED: 'cached',
    UNCACHED: 'uncached',
};
//# sourceMappingURL=resourceDeliveryTypes.js.map